// extracted by mini-css-extract-plugin
module.exports = {"footer":"UserAppendPopup_footer_34a-9","btn":"UserAppendPopup_btn_1_1DC"};